/* RESPONSIBLE TEAM: team-tickets-1 */
import Rule from 'embercom/models/inbox/conversation-rules/rule';

export default Rule.extend({
  entityString: 'sla_rule',
  subRouteString: 'slas',
  allowedRuleActions: ['apply-conversation-sla'],
});
